export const APPURL = "https://fruty-zone-pasindu-backend.onrender.com";

export const VALIDATEEMAIL = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
export const VALIDATEPHONE = "^[0-9]{10}$";
